import { MODAL_DIALOG_OPEN, MODAL_DIALOG_CLOSE } from '../actions/modal_dialog'

export const modalDialog = (state = { isModalDialogOpen: false, content: null }, action) => {
  switch (action.type) {
    case MODAL_DIALOG_OPEN:
      return { ...state, isModalDialogOpen: true, content: action.content }
    case MODAL_DIALOG_CLOSE:
      return { ...state, isModalDialogOpen: false }
    default:
      return state
  }
}
